<template>
  <div
    v-show="topShow"
    class="topBox"
    @click="toTop">
    <i class="el-icon-arrow-up top-icon"></i>
  </div>
</template>

<script>
export default {
  name: 'toTop',
  props:{
    el:{
      // 从父组件获取出现滚动条的元素
      type: HTMLElement,
      default: null
    }
  },
  data () {
    return {
      topShow: false,
      timer: null,
      speed: 0
    }
  },
  mounted(){
    document.addEventListener('scroll',this.show,true)
  },
  beforeDestroy() {
    document.removeEventListener('scroll',this.show,true)
  },
  methods: {
    show(){
      let scrollTop = this.el.scrollTop
      if( scrollTop > 200 ){
        this.topShow=true
      }else{
        this.topShow=false
      }
    },

    toTop(){
      this.timer=setInterval(()=>{
        this.speed=Math.ceil(this.el.scrollTop / 10)
        this.el.scrollTop = this.el.scrollTop - this.speed
        if(this.el.scrollTop == 0){
          clearInterval(this.timer)
        }
      },10)
    }
  },
}
</script>
<style lang='scss' scoped>
.topBox{
  position: fixed;
  right: 80px;
  bottom: 50px;
  z-index: 10;
  cursor: pointer;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .top-icon{
      font-size: x-large;
      line-height: 50px;
      width: 50px;
      height: 50px;
      text-align: center;
  }
}
</style>
